import styles from "./ScreenWipe.module.css";
import { useEffect, useState } from "react";
import PixelNumber from "../object-graphics/PixelNumber";
import { useRecoilState, useSetRecoilState } from "recoil";
import { currentLevelSelector } from "../../atoms/currentLevelAtom";
import sounds, { SFX } from "../../classes/Sounds";
import { LevelMap } from "../../levels/LevelMap";
import { wait } from "../../helpers/wait";
import { isChangeLevelMenuOpenAtom } from "../../atoms/changeLevelMenuAtom";
import { completedLevelsSelector } from "../../atoms/completedLevelsAtom";

export default function ScreenWipe({ onDone, onCompleteLastLevel }) {
  const [animationPhase, setAnimationPhase] = useState("initial");
  const [showLevelNumber, setShowLevelNumber] = useState(false);
  const [currentLevel, setCurrentLevel] = useRecoilState(currentLevelSelector);
  const setIsChangeLevelMenuOpen = useSetRecoilState(isChangeLevelMenuOpenAtom);
  const [completedLevels, setCompletedLevels] = useRecoilState(
    completedLevelsSelector
  );

  useEffect(() => {
    const effect = async () => {
      await wait(1200);
      setAnimationPhase("in");
    };
    void effect();
  }, []);

  const onGoToNextLevel = () => {
    const levelsArray = Object.keys(LevelMap);
    const currentIndex = levelsArray.indexOf(currentLevel);
    const nextLevel = levelsArray[currentIndex + 1];

    //Close level select if it is open
    setIsChangeLevelMenuOpen(false);

    //Save this level to known completed levels
    setCompletedLevels({
      ...completedLevels,
      [currentLevel]: true,
    });

    const LAST_LEVEL_KEY = "5-9";

    if (currentLevel === LAST_LEVEL_KEY) {
      sounds.stopMusic();
      onCompleteLastLevel();
      return;
    }

    //Go to next level
    sounds.playSfx(SFX.SOMETHING_APPEARS);
    setCurrentLevel(nextLevel ?? "1-1");
  };

  return (
    <div
      onTransitionEnd={async () => {
        //Only fire the first time
        if (animationPhase === "in") {
          // Display current Level Number after a delay
          await wait(200);
          setShowLevelNumber(true);

          // Show the number change after a delay
          await wait(800);
          onGoToNextLevel();

          // Transition out after a delay
          await wait(800);
          setAnimationPhase("out");
          return;
        }

        if (animationPhase === "out") {
          onDone();
        }
      }}
      className={`${styles.screenWipe} ${styles[animationPhase]}`}
    >
      <div className={styles.levelNumberContainer}>
        {showLevelNumber && <PixelNumber number={currentLevel} />}
      </div>
    </div>
  );
}
